import React from 'react';
import Projects from '../Projects/Projects';
import Services from '../Sevices/Sevices';
import Banner from './Banner';
import CardHome from './CardHome';
import Contact from './Contact';
import SkillsOverView from './SkillsOverView';
import WhatIDo from './WhatIDo';


const Home = () => {
    return (
        <div>
            <Banner />
            <WhatIDo></WhatIDo>
            <Services />
            <SkillsOverView />
            {/* <CardHome></CardHome> */}
            <Projects home={true} size={2} />
            <Contact /> 
        </div>
    );
};

export default Home;